module.exports = __webpack_public_path__ + "static/chilli-beans-5-66e0b12084f89734dad3f20f422a46de.jpg";